import type { EntityId } from './types';
import type { Tag } from '../content/tags';

/** Events emitted by the simulation during a tick; the room filters and forwards them. */
export type SimEvent =
  | { t: 'hit'; id: EntityId; x: number; y: number; dmg: number; crit: boolean; tag?: Tag; heal?: boolean; team: number }
  | { t: 'proj'; id: EntityId; x: number; y: number; vx: number; vy: number; r: number; visual: string; team: number; until: number; owner: EntityId; orbit?: { radius: number; angVel: number } }
  | { t: 'projEnd'; id: EntityId; x: number; y: number }
  | { t: 'fx'; kind: string; x: number; y: number; r?: number; a?: number; team?: number; x2?: number; y2?: number; id?: EntityId }
  | { t: 'death'; id: EntityId; kind: string; x: number; y: number; name?: string; def?: string; killer?: string }
  | { t: 'levelup'; id: EntityId; level: number; x: number; y: number }
  | { t: 'rankup'; id: EntityId; rank: number; x: number; y: number }
  | { t: 'crowd'; id: EntityId; effect: string; by: string; kind: 'harm' | 'help'; x: number; y: number }
  | { t: 'cast'; id: EntityId; skill: string; x: number; y: number }
  | { t: 'pickup'; id: EntityId; type: string; what?: string; amount?: number }
  | { t: 'announce'; key: string; vars?: Record<string, string | number>; color?: string }
  | { t: 'feed'; key: string; vars: Record<string, string | number> }
  | { t: 'telegraph'; x: number; y: number; r: number; until: number; kind: 'circle' | 'line'; x2?: number; y2?: number }
  | { t: 'status'; id: EntityId; status: string; on: boolean }
  | { t: 'shake'; id: EntityId; power: number };

export class EventBuffer {
  list: SimEvent[] = [];
  push(e: SimEvent): void {
    this.list.push(e);
  }
  drain(): SimEvent[] {
    const out = this.list;
    this.list = [];
    return out;
  }
}
